import React from 'react';
import { useNavigate } from 'react-router-dom';
import './AdminTestPaymentScreen.css';
import backIcon from '../../assets/backspace-icon.png';

function AdminTestPaymentScreen() {
  const navigate = useNavigate();

  const handleRealPiPayment = () => {
    console.log('🚀 [AdminTestPayment] Starting Pi.createPayment() ...');

    if (!window.Pi) {
      console.error('❌ [AdminTestPayment] Pi SDK not found in window.');
      alert('Pi SDK not available. Please open inside Pi Browser.');
      return;
    }

    console.log('🟢 [AdminTestPayment] Pi SDK detected. Creating payment...');

    window.Pi.createPayment(
      {
        amount: 1,
        memo: 'Test payment to BarterFi (Pi Testnet)',
        metadata: { type: 'test_payment', admin: true },
        // ✅ Explicitly define receiver!
        receiver: 'GBA7RETJ4I7EFQI74VFLTAKVBXWKNGYVQF2NIYBCJ5U2DMXYDJM6OHQG',
      },
      {
        onReadyForServerApproval: async (paymentId) => {
          console.log('✅ [AdminTestPayment] 🔑 onReadyForServerApproval:', paymentId);
          // Optional: Call backend to approve if you wish
        },
        onReadyForServerCompletion: async (paymentId, txid) => {
          console.log('✅ [AdminTestPayment] 🔑 onReadyForServerCompletion:');
          console.log('  📌 paymentId:', paymentId);
          console.log('  📌 txid:', txid);

          console.log('📡 [AdminTestPayment] Sending txid to backend verify route...');
          const res = await fetch('/api/test-payment/verify', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ transaction_id: txid }),
          });

          const data = await res.json();
          console.log('✅ [AdminTestPayment] /verify responded:', data);

          if (data && data.verified) {
            alert('✅ Pi payment done & verified!');
          } else {
            alert('⚠️ Payment finished but backend did not verify.');
          }
        },
        onCancel: (paymentId) => {
          console.warn('⚠️ [AdminTestPayment] 🔑 onCancel:', paymentId);
          alert('❌ Pi Payment was cancelled by the user.');
        },
        onError: (error) => {
          console.error('❌ [AdminTestPayment] 🔑 onError:', error);
          alert(`❌ Pi Payment failed: ${error?.message || 'Unknown error'}`);
        },
      }
    );
  };

  return (
    <div className="admin-test-payment-container">
      {/* ✅ Fixed Top Bar */}
      <div className="admin-test-payment-topbar">
        <img
          src={backIcon}
          alt="Back"
          className="admin-test-payment-back-icon"
          onClick={() => navigate(-1)}
        />
        <h2>Admin Pi Test Payment</h2>
      </div>

      <div className="admin-test-payment-body">
        <p>This sends **real Testnet Pi** to your App Wallet for Pi’s Step 11.</p>
        <button className="admin-test-payment-button" onClick={handleRealPiPayment}>
          Send 1 Pi Testnet Payment
        </button>
      </div>
    </div>
  );
}

export default AdminTestPaymentScreen;
